<template>
    <p class="mt-4 text-dark">
        Please select your car brand and model below. If your model is not
        listed in our database, please select "Not found, enter below" and
        enter your model in the text box.
    </p>

    <input-select
        class="mt-4"
        :options="manufacturers"
        labelKey="name"
        valueKey="id"
        :error="errors['tyre_details.vehicle_manufacturer_id']"
        :modelValue="manufacturer"
        @update:modelValue="$emit('update:manufacturer', $event)"
        placeholder="Car Manufacturer"
    ></input-select>

    <input-select
        v-if="!manufacturerNotFound"
        class="mt-4"
        :options="models"
        labelKey="name"
        valueKey="id"
        :error="errors['tyre_details.vehicle_model_id']"
        @update:modelValue="$emit('update:model', $event)"
        :modelValue="model"
        placeholder="Car Model"
    ></input-select>

    <input-basic
        class="mt-4"
        v-if="manufacturerNotFound"
        @update:modelValue="$emit('update:model', $event)"
        :modelValue="model"
        placeholder="Enter your car make and model"
        :error="errors['tyre_details.vehicle_model_id']"
    ></input-basic>

    <input-error v-if="errors['tyre_details.vehicle_model_id']">
        Please select your car
    </input-error>
</template>
<script>
import InputSelect from '@/Components/Forms/Inputs/InputSelect.vue';
import InputBasic from '@/Components/Forms/Inputs/InputBasic.vue';
import InputError from '@/Components/Forms/Inputs/InputError.vue';

export default {
    components: { InputSelect, InputError, InputBasic },
    props: {
        manufacturer: Object,
        model: Object,
        errors: Object,
        manufacturerNotFound: Boolean
    },
    data() {
        return {
            manufacturers: [],
            models: []
        }
    },
    mounted() {
        this.getManufacturers();

        if (this.manufacturer) {
            this.getModels();
        }
    },
    watch: {
        async manufacturer(manufacturer) {
            console.log(manufacturer);

            this.$emit("update:manufacturerNotFound", manufacturer.id === "not-found");

            if (manufacturer.id !== "not-found") {
                await this.getModels();
            } else {
                this.models = [];
            }

            if (this.models && this.models[0]) {
                this.$emit("update:model", this.models[0]);
            } else {
                this.$emit("update:model", null);
            }
        }
    },
    methods: {
        async getManufacturers() {
            const response = await axios.get(this.route("api.manufacturers.index"));

            const manufacturers = response.data;
            manufacturers.push({id: "not-found", name: "Not found"});

            this.manufacturers = manufacturers;
        },
        async getModels() {
            const response = await axios.get(
                this.route("api.manufacturers.models.index", this.manufacturer)
            );

            this.models = response.data;
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
